import { FC, ReactNode, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Objective } from '../../utils/models/Objective';
import ConfirmationDialogModalMultiAction from '../Widgets/Modals/ConfirmationDialogModalMultiAction';

interface Props {
  objective: Objective;
  isOpen: boolean;
  onClosed?: () => void;
  onDisconnect: () => void;
  toggle: () => void;
  zIndex?: number;
}

const PersonalObjectiveItemDisconnectModal: FC<Props> = ({
  objective,
  isOpen,
  onClosed = () => {
    //do nothing
  },
  toggle,
  onDisconnect,
  zIndex,
}) => {
  const { formatMessage } = useIntl();

  const [description, actions] = useMemo(() => {
    return [
      formatMessage(
        {
          id: 'app.views.person.personal_objective_item_disconnect_modal.dialog.description',
          defaultMessage:
            'Are you sure you want to disconnect the following objective from its parent? <p>{objective}</p>',
        },
        {
          objective: objective.name,
          p: (chunks: ReactNode) => (
            <p className="fw-bold text-secondary mt-2">
              <i
                className="fe fe-arrow-right text-secondary me-2 position-relative"
                style={{ top: '1px' }}
              />
              {chunks}
            </p>
          ),
        }
      ),
      [
        {
          text: formatMessage({
            id: 'app.views.person.personal_objective_item_disconnect_modal.cancel',
            defaultMessage: 'Cancel',
          }),
          color: 'light',
          onClick: toggle,
          className: 'col-md-2',
          outline: false,
        },
        {
          text: formatMessage({
            id: 'app.views.person.personal_objective_item_disconnect_modal.disconnect',
            defaultMessage: 'Disconnect',
          }),
          color: 'danger',
          onClick: onDisconnect,
          className: 'col-md-3',
          outline: false,
        },
      ],
    ];
  }, [objective.name, formatMessage, toggle, onDisconnect]);

  return (
    <ConfirmationDialogModalMultiAction
      isOpen={isOpen}
      onClosed={onClosed}
      toggle={toggle}
      actions={actions}
      className="col-md-6"
      zIndex={zIndex}
      title={formatMessage({
        id: 'app.views.person.personal_objective_item_disconnect_modal.dialog.title',
        defaultMessage: 'Disconnect from parent objective',
      })}
      description={description}
    />
  );
};

export default PersonalObjectiveItemDisconnectModal;
